// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockOutlinedSvg from "@ant-design/icons-svg/es/asn/LockOutlined";
import AntdIcon from '../components/AntdIcon';

var LockOutlined = function LockOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockOutlinedSvg
  }));
};

LockOutlined.displayName = 'LockOutlined';
export default React.forwardRef(LockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LockOutlined.js
// module id = 1433
// module chunks = 0